import cn from 'clsx';
import { useMemo, JSX } from 'react';

import { BasicPill } from './BasicPill';
import { PillType } from './enums';

interface IFilledPillProps {
  readonly text: string;
  readonly type?: PillType;
  readonly icon?: JSX.Element | null;
  readonly extraClassName?: string;
}

export function FilledPill({
  text,
  type,
  icon,
  extraClassName,
}: IFilledPillProps) {
  const pillStyle = useMemo(() => {
    switch (type) {
      case PillType.Error:
        return 'border-red-50 bg-red-50 text-red-700';
      case PillType.Info:
        return 'border-sky-50 bg-sky-50 text-sky-700';
      case PillType.Success:
        return 'border-green-50 bg-green-50 text-green-700';
      case PillType.Primary:
      default:
        return 'border-primary bg-primary text-white';
    }
  }, [type]);

  return (
    <BasicPill extraClassName={cn(pillStyle, extraClassName)}>
      {icon ? icon : null}
      {text}
    </BasicPill>
  );
}
